import React from 'react';

const FooterDetails = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2 className="footer-title">BLOODLINE DEV</h2>
        <p className="footer-copy">&copy; 2024 DexBuild. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterDetails;
